export enum TaskDetailsTab {
  FILES = 'FILES',
  MAILS_AND_NOTES = 'MAILS_AND_NOTES',
  MESSAGES = 'MESSAGES',
}
